"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectSpeakActivity = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactSay = _interopRequireDefault(require("react-say"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _SayAlt = _interopRequireDefault(require("./SayAlt"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // TODO: [P4] Consider moving this feature into BasicActivity
//       And it has better DOM position for showing visual spoken text
// TODO: [P3] We should add a "spoken" or "speakState" flag to indicate whether this activity is going to speak, or spoken


var connectSpeakActivity = function connectSpeakActivity() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var language = _ref.language,
        markActivity = _ref.markActivity;
    var activity = _ref2.activity;
    return {
      language: language,
      markAsSpoken: function markAsSpoken() {
        return markActivity(activity, 'speak', false);
      },
      selectVoice: function selectVoice(voices) {
        voices = [].slice.call(voices);
        return voices.find(function (_ref3) {
          var lang = _ref3.lang;
          return lang === activity.locale;
        }) || voices.find(function (_ref4) {
          var lang = _ref4.lang;
          return lang === language;
        }) || voices.find(function (_ref5) {
          var lang = _ref5.lang;
          return lang === window.navigator.language;
        }) || voices.find(function (_ref6) {
          var lang = _ref6.lang;
          return lang === 'en-US';
        }) || voices[0];
      }
    };
  }].concat(selectors));
};

exports.connectSpeakActivity = connectSpeakActivity;

var Speak = function Speak(_ref7) {
  var activity = _ref7.activity,
      markAsSpoken = _ref7.markAsSpoken,
      selectVoice = _ref7.selectVoice,
      styleSet = _ref7.styleSet;

  if (!activity) {
    return false;
  }

  var _activity$attachments = activity.attachments,
      attachments = _activity$attachments === void 0 ? [] : _activity$attachments,
      speak = activity.speak,
      text = activity.text;
  var lines = [speak || text];
  attachments.forEach(function (_ref8) {
    var _ref8$content = _ref8.content;
    _ref8$content = _ref8$content === void 0 ? {} : _ref8$content;
    var speak = _ref8$content.speak,
        contentType = _ref8.contentType;

    if (contentType === 'application/vnd.microsoft.card.adaptive') {
      lines.push(speak);
    }
  });
  var singleLine = lines.filter(function (line) {
    return line;
  }).join('\r\n');
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactSay.default, {
    onEnd: markAsSpoken,
    speak: singleLine,
    voice: selectVoice
  }), !!styleSet.options.showSpokenText && _react.default.createElement(_SayAlt.default, {
    speak: singleLine,
    voice: selectVoice
  }));
};

Speak.propTypes = {
  activity: _propTypes.default.shape({
    attachments: _propTypes.default.arrayOf(_propTypes.default.shape({
      speak: _propTypes.default.string,
      subtitle: _propTypes.default.string,
      text: _propTypes.default.string,
      title: _propTypes.default.string
    })),
    speak: _propTypes.default.string,
    text: _propTypes.default.string
  }).isRequired,
  markAsSpoken: _propTypes.default.func.isRequired,
  selectVoice: _propTypes.default.func.isRequired,
  styleSet: _propTypes.default.shape({
    options: _propTypes.default.shape({
      showSpokenText: _propTypes.default.bool.isRequired
    }).isRequired
  }).isRequired
};

var _default = connectSpeakActivity(function (_ref9) {
  var styleSet = _ref9.styleSet;
  return {
    styleSet: styleSet
  };
})(Speak);

exports.default = _default;